import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { AuctionPurchase, Invoice, Person } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuctionPurchaseDialogComponent } from '../auction-purchase-dialog/auction-purchase-dialog.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-invoice-overview',
    templateUrl: './invoice-overview.component.html',
    styleUrls: ['./invoice-overview.component.scss'],
})
export class InvoiceOverviewComponent implements OnInit {
    private router = inject(Router);
    private uow = inject(ArkUnitOfWork);
    private auth = inject(AuthService);
    private appInfo = inject(AppInformationService);

    invoices: Invoice[];

    auctionItems: any[] = [];
    people: Person[];
    auctionItemTypes = ['Live', 'Silent', 'Raffle Line'];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    constructor() {}

    async ngOnInit() {
        const people = (await this.uow.people.all(null, 'family')) as Person[];
        this.people = _.orderBy(
            people.filter((person) => !person.deceasedDate),
            ['lastName', 'firstName'],
            ['asc', 'asc']
        );
        // this.reviewOnly = !this.auth.hasRole('Executive:Clerk');
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.invoices = (await this.uow.invoices.whereActive(null, 'invoiceLines, person')) as Invoice[];
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }

    rowPrepare(e) {
        // if (e.rowType === 'data') {
        //     if (!!e.data.approved) {
        //         e.rowElement.className = e.rowElement.className + ' approved';
        //     }
        //     if (!!e.data.declined) {
        //         e.rowElement.className = e.rowElement.className + ' declined';
        //     }
        //     if (!e.data.approved && !e.data.declined) {
        //         e.rowElement.className = e.rowElement.className + ' waiting-for-vote';
        //     }
        // }
    }
    rowDoubleClick(e) {
        this.open(e.data.id);
    }
    async open(invoiceId?: any) {
        this.router.navigate(['/invoices/' + (!!invoiceId ? invoiceId : 'new')]);
    }

    async delete(selectedRow: any) {
        const result = await confirm('Are you sure you want to delete this Invoice?', this.appInfo.settings.church.toUpperCase());
        if (!result) return;
        this.appInfo.pleaseWaitShow();
        const invoice = await this.uow.invoices.byId(selectedRow.id, 'invoiceLines') as Invoice;
        invoice.invoiceLines.forEach(line => {
            line.auctionPurchaseId = null;
            line.deleted = new Date();
            line.deletedBy = this.auth.currentUser.userName;
        });
        invoice.deleted = new Date();
        invoice.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async print() {
        // const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        // if (!selectedRow) return;
        // await this.utility.printProposal(selectedRow.id);
    }
}
